// extracted by mini-css-extract-plugin
export var filterIncDec = "_a0-0";
export var leftBorder = "_a0-1";
export var rightBorder = "_a0-2";
export var stringInput = "_a0-3";